import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Components from "./pages/Components.vue";
import Landing from "./pages/Landing.vue";
import Login from "./pages/Login.vue";
import Register from "./pages/Register.vue";
import Profile from "./pages/Profile.vue";
import Home from "./views/Home.vue";
import Product from "./views/Product.vue";
import Network from "./views/Network.vue";
import Cost from "./views/Cost.vue";
import Bill from "./views/Bill.vue";
import Currency from "./views/Currency.vue";
import Settlement from "./views/Settlement.vue";
import Exchange from "./views/Exchange.vue";
import Plan from "./views/Plan.vue";
import Enterprise from "./views/Enterprise.vue";
import Account from "./views/Account.vue";
import Security from "./views/Security.vue";
import Organization from "./views/Organization.vue";
import Fund from "./views/Fund.vue";

import Number from "./views/Number.vue";
import Help from "./views/Help.vue";
import HelpDetails from "./views/HelpDetails.vue";
import Download from "./views/Download.vue";
import Egg from "./views/Egg.vue";
import AboutAll from "./views/AboutAll.vue";
import NumberAll from "./views/NumberAll.vue";
import HomeAll from "./views/HomeAll.vue";
import Link from "./views/link.vue";
import ProductAll from "./views/ProductAll.vue";
import HelpAll from "./views/HelpAll.vue";
Vue.use(Router);

export default new Router({
  linkExactActiveClass: "active",
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    // {
    //   path: "/",
    //   name: "home",
    //   title: "首页",
    //   components: {
    //     header: AppHeader,
    //     default: Home,
    //     // footer: AppFooter,
    //   }
    // },
    {
      path: "/product",
      name: "product",
      title: "产品与服务",
      components: {
        header: AppHeader,
        default: Product,
        footer: AppFooter,
      }
    },
    {
      path: "/network",
      name: "network",
      title: "全球支付网络",
      components: {
        header: AppHeader,
        default: Network,
        footer: AppFooter,
      }
    },
    // {
    //   path: "/test",
    //   name: "components",
    //   title: "组件",
    //   components: {
    //     header: AppHeader,
    //     default: Components,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/landing",
    //   name: "landing",
    //   components: {
    //     header: AppHeader,
    //     default: Landing,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/login",
    //   name: "login",
    //   components: {
    //     header: AppHeader,
    //     default: Login,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: "/register",
    //   name: "register",
    //   components: {
    //     header: AppHeader,
    //     default: Register,
    //     footer: AppFooter
    //   }
    // },
    // {
    //   path: '/profile', name: 'profile',
    //   components: {
    //     header: AppHeader,
    //     default: Profile,
    //     footer: AppFooter
    //   }
    // },
    {
      path: '/cost',
      name: 'cost',
      title: '费用管理',
      components: { header: AppHeader, default: Cost, footer: AppFooter }
    },
    {
      path: '/bill',
      name: 'bill',
      title: '账单支付',
      components: { header: AppHeader, default: Bill, footer: AppFooter }
    },
    {
      path: '/currency',
      name: 'currency',
      title: '多币种结算与智能换汇',
      components: { header: AppHeader, default: Currency, footer: AppFooter }
    },
    { path: '/settlement', name: 'settlement', title: '多币种结算', components: { header: AppHeader, default: Settlement, footer: AppFooter } },
    { path: '/exchange', name: 'exchange', title: '智能换汇', components: { header: AppHeader, default: Exchange, footer: AppFooter } },
    { path: '/plan', name: 'plan', title: '企业支付方案', components: { header: AppHeader, default: Plan, footer: AppFooter } },
    { path: '/enterprise', name: 'enterprise', title: '企业卡', components: { header: AppHeader, default: Enterprise, footer: AppFooter } },
    { path: '/account', name: 'account', title: '灵活账户体系', components: { header: AppHeader, default: Account, footer: AppFooter } },
    { path: '/security', name: 'security', title: '合规保障', components: { header: AppHeader, default: Security, footer: AppFooter } },
    { path: '/organization', name: 'organization', title: '正规持牌支付机构', components: { header: AppHeader, default: Organization, footer: AppFooter } },
    { path: '/fund', name: 'fund', title: '资金安全', components: { header: AppHeader, default: Fund, footer: AppFooter } },
    { path: '/number/:id', name: 'numberAll', title: '数字生活服务', components: { header: AppHeader, default: NumberAll } },
    
    { path: '/help', name: 'help', title: '帮助与支持', components: { header: AppHeader, default: HelpAll, footer: AppFooter } },
    { path: '/help/:id', name: 'helpDetails', title: '帮助详情', components: { header: AppHeader, default: HelpDetails, footer: AppFooter } },
    { path: '/download', name: 'download', title: '下载中心', components: { header: AppHeader, default: Download, footer: AppFooter } },
    { path: '/egg/:id', name: 'egg', title: '彩蛋页面', components: { default: Egg } },
    { path: '/about/:id', name: 'aboutAll', title: '关于我们', components: { header: AppHeader, default: AboutAll  } },
    { path: '/contact', redirect: '/about/0' },
    { path: '/', name: 'homeAll', title: '首页', components: { header: AppHeader, default: HomeAll  } },
    { path: '/link/:id', name: 'link', title: '协议链接', components: {  default: Link } },
    { path: '/product/:id', name: 'productAll', title: '产品与服务', components: {  header: AppHeader, default: ProductAll } }
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
